import { z } from "zod";
export const region = z.union([
    z.literal(""),
    z.literal("Alberta"),
    z.literal("British Columbia"),
    z.literal("Manitoba"),
    z.literal("New Brunswick"),
    z.literal("Newfoundland and Labrador"),
    z.literal("Nova Scotia"),
    z.literal("Northwest Territories"),
    z.literal("Nunavut"),
    z.literal("Ontario"),
    z.literal("Prince Edward Island"),
    z.literal("Quebec"),
    z.literal("Saskatchewan"),
    z.literal("Yukon"),
    z.literal("Africa"),
    z.literal("Asia"),
    z.literal("Australia/New Zealand"),
    z.literal("United States"),
    z.literal("Europe"),
    z.literal("Central America"),
    z.literal("South America"),
]);
export const regionLookup = {
    "1": "Ontario",
    "2": "Quebec",
    "3": "British Columbia",
    "4": "Alberta",
    "5": "United States",
    "6": "Europe",
    "7": "Central America",
    "8": "South America",
    "9": "Manitoba",
    "10": "New Brunswick",
    "11": "Newfoundland and Labrador",
    "12": "Nova Scotia",
    "13": "Prince Edward Island",
    "14": "Saskatchewan",
    "15": "Northwest Territories",
    "16": "Nunavut",
    "17": "Yukon",
    "18": "Asia",
    "19": "Africa",
    "20": "Australia/New Zealand",
    "??": "",
    AB: "Alberta",
    AK: "United States",
    AL: "United States",
    Alabama: "United States",
    Alajuela: "Central America",
    Alaska: "United States",
    "Antigua and Barbuda": "Central America",
    AR: "United States",
    Argentina: "South America",
    Arizona: "United States",
    Arkansas: "United States",
    "Atlanta,ga": "United States",
    Australia: "Australia/New Zealand",
    AZ: "United States",
    BC: "British Columbia",
    Bolivia: "South America",
    Brazil: "South America",
    "British Columbia": "British Columbia",
    "British Columbia": "British Columbia",
    BY: "",
    CA: "United States",
    Caldas: "South America",
    California: "United States",
    Cancun: "Central America",
    "Cape Town": "Africa",
    "Cayman Islands": "Central America",
    Chile: "South America",
    CO: "United States",
    Colombia: "South America",
    Colorado: "United States",
    Columbia: "South America",
    Connecticut: "United States",
    CT: "United States",
    "Cusco Peru": "Central America",
    DC: "United States",
    DE: "United States",
    Delaware: "United States",
    "District of Columbia": "United States",
    "Domincan Republic": "Central America",
    "Dominican Republic": "Central America",
    "Dr Congo": "Africa",
    Ecuador: "South America",
    Ethiopia: "",
    FL: "United States",
    Florida: "United States",
    GA: "United States",
    Georgia: "United States",
    Ghana: "Africa",
    Greece: "Europe",
    Hawaii: "United States",
    HI: "United States",
    HO: "United States",
    Honduras: "Central America",
    IA: "United States",
    Iceland: "Europe",
    ID: "United States",
    Idaho: "United States",
    IL: "United States",
    Illinois: "United States",
    IN: "United States",
    India: "Asia",
    Indiana: "United States",
    Iowa: "United States",
    Ireland: "Europe",
    Italy: "Europe",
    Jordan: "Asia",
    Kansas: "United States",
    Kentucky: "United States",
    Kenya: "Africa",
    Kinshasa: "Africa",
    KS: "United States",
    KY: "United States",
    LA: "United States",
    Louisiana: "United States",
    MA: "United States",
    Madagascar: "Africa",
    Magdalena: "",
    Maine: "United States",
    Maryland: "United States",
    Massachusetts: "United States",
    MB: "Manitoba",
    MD: "United States",
    ME: "United States",
    MEXICO: "Central America",
    MI: "United States",
    Michigan: "United States",
    Minnesota: "United States",
    Mississippi: "United States",
    Missouri: "United States",
    MN: "United States",
    MO: "United States",
    Montana: "United States",
    Morocco: "Africa",
    Moyobamba: "South America",
    MS: "United States",
    MT: "United States",
    "N/a": "",
    NB: "New Brunswick",
    NC: "United States",
    ND: "United States",
    NE: "United States",
    Nebraska: "United States",
    Nevada: "United States",
    "New Hampshire": "United States",
    "New Jersey": "United States",
    "New Mexico": "United States",
    "New York": "United States",
    "New York, Ny": "United States",
    "New Zealand": "Australia/New Zealand",
    NH: "United States",
    NJ: "United States",
    NL: "Newfoundland and Labrador",
    NM: "United States",
    "North Carolina": "United States",
    "North Dakota": "United States",
    "Nova Scotia": "Nova Scotia",
    "Nova Scotia": "Nova Scotia",
    NS: "Nova Scotia",
    NV: "United States",
    NY: "United States",
    OH: "United States",
    Ohio: "United States",
    OK: "United States",
    Oklahoma: "United States",
    ON: "Ontario",
    OR: "United States",
    Oregon: "United States",
    PA: "United States",
    Panama: "Central America",
    PE: "Prince Edward Island",
    Pennsylvania: "United States",
    Peru: "Central America",
    PI: "Prince Edward Island",
    PR: "United States",
    "Puerto Rico": "United States",
    QC: "Quebec",
    "Rhode Island": "United States",
    RI: "United States",
    Rwanda: "Africa",
    SC: "United States",
    SD: "United States",
    Senegal: "Africa",
    Seoul: "Asia",
    SK: "Saskatchewan",
    "SOPHIA ANTIPOLIS": "Europe",
    "South Carolina": "United States",
    "South Dakota": "United States",
    Sweden: "Europe",
    Switzerland: "Europe",
    Tanzania: "Africa",
    TBC: "",
    Tennessee: "United States",
    Texas: "United States",
    TN: "United States",
    "Trinidad and Tobago": "Central America",
    Turkey: "Europe",
    TX: "United States",
    Uganda: "Africa",
    uk: "Europe",
    "United-States": "United States",
    "United Kingdom": "Europe",
    US: "United States",
    UT: "United States",
    Utah: "United States",
    VA: "United States",
    Vermont: "United States",
    VI: "United States",
    Virginia: "United States",
    "Virgin Islands": "United States",
    VT: "United States",
    WA: "United States",
    Washington: "United States",
    "Washington, Dc": "United States",
    Washinton: "United States",
    "West Virginia": "United States",
    WI: "United States",
    Wisconsin: "United States",
    WV: "United States",
    WY: "United States",
    Wyoming: "United States",
    YT: "Yukon",
    京都府: "Asia",
};
//# sourceMappingURL=regions-list.js.map